// Events invalidate an in-flight snapshot and request one trailing refresh.
export function createCoalescedRefresh(fetchSnapshot, applySnapshot, { delay = 120, onError = () => {} } = {}) {
  let disposed = false;
  let running = false;
  let dirty = false;
  let revision = 0;
  let timer;
  async function run() {
    if (disposed) return;
    if (running) { dirty = true; return; }
    running = true;
    const startedAt = revision;
    try {
      const data = await fetchSnapshot();
      if (!disposed && startedAt === revision) applySnapshot(data);
    } catch (error) {
      if (!disposed) onError(error);
    } finally {
      running = false;
      if (!disposed && dirty) { dirty = false; schedule(); }
    }
  }
  function schedule() {
    if (disposed) return;
    revision++;
    clearTimeout(timer);
    timer = setTimeout(run, delay);
  }
  return {
    refresh: schedule,
    start: run,
    dispose() { disposed = true; clearTimeout(timer); },
  };
}
